import React, { useState } from 'react'
import { Image, Link } from '../base-ui'
import { generateUrl } from '../../utils'
import { IoCloseCircleOutline } from 'react-icons/io5'
import { thumbnailSrc } from '../../utils/news'

function StickyAdBottom({ ad, imgSrc, href, title, displayStyle = 'media_text', position = 'bottom', style }) {
    const [visible, setVisible] = useState(true)
    const mainStyle = {
        width: '100vw',
        backgroundColor: '#ffffff',
        height: '56px',
        position: 'fixed',
        zIndex: '99',
        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
        display: visible === true ? 'flex' : 'none',
        alignItems: 'center',
    }
    if (position === 'bottom') mainStyle.bottom = 0
    else if (position === 'top') {
        mainStyle.top = 0
        mainStyle.position = 'sticky'
    }
    const linkStyle =
        'display: block; margin: 0 auto; padding: 0 0.5rem; a { display: flex; justify-content: center; align-items: center; gap: 0.25rem;}'
    return (
        <div style={{ ...mainStyle, ...style }}>
            <Link href={href ?? generateUrl(ad, 'news')} style={linkStyle}>
                {(imgSrc || ad?.thumbnail?.file?.hash) && <div style={{ minWidth: '4rem' }}>
                    <Image
                        src={imgSrc ?? thumbnailSrc(ad.thumbnail)}
                        alt="picture"
                        width={displayStyle === 'media_text' ? 90 : 350}
                        height={56}
                    />
                </div>}
                {displayStyle === 'media_text' && <>
                    <div
                        style={{
                            fontSize: '0.9rem',
                            textAlign: 'center',
                            overflow: 'hidden',
                            display: '-webkit-box',
                            WebkitLineClamp: '2',
                            WebkitBoxOrient: 'vertical',
                        }}
                    >
                        {title ?? ad.title}
                    </div>
                    <div style={{
                        backgroundColor: 'transparent',
                        color: '#ef233c',
                        display: 'flex',
                        alignItems: 'center',
                        fontSize: '22px',
                        padding: '3px 8px'
                    }} onClick={(e) => {
                        e.preventDefault()
                        setVisible(false)
                    }}>
                        <IoCloseCircleOutline />
                    </div>
                </>}
            </Link>
        </div >
    )
}

export default StickyAdBottom